import React from 'react';
import './LandingPage.css';
import darkLogo from '../../assets/nura-logo-dark.svg';

const LandingPage = ({ onNewChat }) => {
  const handleStartChat = () => {
    if (typeof onNewChat === 'function') {
      onNewChat();
    }
  };

  return (
    <div className="landing-wrapper">
      <div className="landing-container dark">
        <div className="landing-content">
          <div className="hero-section">
            <h1>Welcome to NuraAI</h1>
            <p className="subtitle">Your intelligent chat companion</p>
            <div className="cta-section">
              <button 
                className="start-chat-btn" 
                onClick={handleStartChat}
              >
                Start a New Chat
              </button>
            </div>
          </div>
          
          <div className="features-grid">
            <div className="feature-card">
              <span className="feature-icon">💡</span>
              <h3>Smart Conversations</h3>
              <p>Advanced AI for natural dialogue</p>
            </div>
            <div className="feature-card">
              <span className="feature-icon">🚀</span>
              <h3>Multiple Models</h3>
              <p>Choose from various AI models</p>
            </div>
            <div className="feature-card">
              <span className="feature-icon">💾</span>
              <h3>Chat History</h3>
              <p>Never lose your conversations</p>
            </div>
            <div className="feature-card">
              <span className="feature-icon">⚡</span>
              <h3>Real-time Responses</h3>
              <p>Fast and efficient interactions</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;